<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/components/Calendar/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>